// extracted by mini-css-extract-plugin
export default {"JsxComment":"JsxCommentzXooka4b7dVq"};